__turbopack_context__.v({
  "container": "_4TBPwq_container",
  "label": "_4TBPwq_label",
  "labelActive": "_4TBPwq_labelActive",
  "list": "_4TBPwq_list",
  "tab": "_4TBPwq_tab",
  "tabActive": "_4TBPwq_tabActive",
});
